import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  borderRadius,
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
`

export const container = css`
  position: relative;
  margin: 0 auto;
  max-width: ${width.container.large};
  padding: ${size[40]} ${size[20]};

  ${breakpoint.up('smMd')} {
    padding: ${size[60]};
  }
`

export const carouselControl = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  bottom: auto;
  left: auto;
  right: auto;
  width: ${size[48]};
  height: ${size[48]};
  transform: translateY(-50%);
  background-color: ${theme.palette.background.accent};
  border: none;
  font-size: ${fontSize.xxs};
  font-weight: 400;
  cursor: pointer;
  border-radius: ${borderRadius.circle};
  user-select: none;
  z-index: 1;

  ${breakpoint.down(96)} {
    transform: none;
    bottom: ${size[40]};
    top: auto;
  }
`

export const prevButton = css`
  left: ${size[96]};

  ${breakpoint.down(106)} {
    left: ${size[24]};
    right: auto;
  }

  ${breakpoint.down(96)} {
    right: ${size[80]};
    left: auto;
  }
`

export const nextButton = css`
  right: ${size[96]};

  ${breakpoint.down(106)} {
    right: ${size[24]};
    left: auto;
  }

  ${breakpoint.down(96)} {
    right: ${size[20]};
    left: auto;
  }
`

export const header = css`
  display: flex;
  flex-direction: column;
  gap: ${size[12]};
  text-align: center;
`

export const title = (theme: Theme) => css`
  margin: 0;
  color: ${theme.palette.secondary.mainContrast};
  text-transform: uppercase;
  font-size: ${fontSize.sm};
  font-weight: 700;
`

export const subtitle = css`
  font-size: ${pxToRem(28)};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(38)};
  }
`

export const carousel = css`
  display: flex;
  width: 100%;

  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  scroll-snap-type: x mandatory;
  touch-action: pan-x;
  overscroll-behavior-x: contain;

  & > div {
    scroll-snap-align: start;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  ${breakpoint.up('smMd')} {
    pointer-events: none;
  }
`

export const quotes = css`
  margin-top: ${size[40]};
`

export const quote = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex-basis: 100%;
  flex-shrink: 0;
`

export const avatar = css`
  border-radius: ${borderRadius.circle};
  height: 170px;
  max-width: 170px;
  object-fit: cover;
`

export const content = css``

export const details = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  font-size: ${fontSize.sm};
  font-weight: 700;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${size[4]};
  }
`

export const text = css`
  margin: ${size[32]} 0 ${size[20]};
  font-size: ${fontSize.smMd};
  font-weight: 400;
`

export const name = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
`

export const divider = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
`

export const position = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
`

export const controls = css`
  margin: 0;
  padding: 0 0 ${size[12]};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${size[8]};
  list-style: none;
`

export const indicator = (theme: Theme) => css`
  width: 34px;
  height: 5px;
  background-color: #333;
  opacity: 0.25;
  border: none;
  border-radius: ${theme.borderRadius.sm};
  transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
`

export const activeIndicator = (theme: Theme) => css`
  width: 60px;
  opacity: 1;
  background-color: ${theme.palette.primary.mainContrast};
  transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
`
